export default __webpack_public_path__ + "static/media/news-4.2f4aa295.png";